import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  formSubmitted:any;
  constructor(private userService: UserService,private router: Router, private route: ActivatedRoute,private errorHandler:ErrorHandler) { }

  ngOnInit() {
  }

  ForgotPassword(form: NgForm) {
    debugger;
    console.log(form.value);
    if (!form.invalid) {
      this.userService.forgotPassword(form.value)
        .subscribe((data: any) => {
          swal('','Link has been sent to your Email!','success');
        },
          (error) => {
            this.errorHandler.HandlerError(error);
          });
    } else
      this.formSubmitted = true;
  }


}



// WEBPACK FOOTER //
// ./src/app/registration/forgot-password/forgot-password.component.ts